export const POPULATE_AZURE = 'LandingZonesPopulateAzure'
export const POPULATE_AWS = 'LandingZonesPopulateAws'

export const POPULATE_CONNECTED = 'LandingZonesPopulateConnected'
export const POPULATE_DISCONNECTED = 'LandingZonesPopulateDisconnected'

export const SET_LOADED = 'LandingZonesSetLoaded'

export const SET_FORMAT = 'LandingZonesSetFormat'
export const SET_FORMAT_LIST = 'LandingZonesSetFormatList'
export const SET_FORMAT_MODE = 'LandingZonesSetFormatMode'